import { settingsManagement } from "core/UrlEndpoints";
import CrudService from "./CrudService";
import { fetchDataJson } from "core/FetchApi";

class SettingsManagementService extends CrudService {
  constructor() {
    super(settingsManagement);
  }

  async getByName(settingName) {
    return fetchDataJson(`${settingsManagement}/GetByName?settingName=${settingName}`, {
      method: "GET",
    });
  }
}

export default new SettingsManagementService();
